import React from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import { observer } from "mobx-react";
import { Segment, Card, Image, Form, Radio } from "semantic-ui-react";
import MediaItemDownloadInfoSection from "./MediaItemDownloadInfoSection";
import MediaItem from "~/models/Media/MediaItem";

const IndividualDownload = observer(({ mediaItems, t, token, model, setProperty, tourIsArchived }) => (
  <Segment className="individual-download">
    <h3 id="individual-download">{t("clientPanelDownload:downloadIndividualFiles")}</h3>
    <Form.Field
      control={Radio}
      toggle
      label={t("clientPanelDownload:useShortFilename")}
      checked={model.useShortFilenamesChecked}
      onChange={() => setProperty("useShortFilenamesChecked", !model.useShortFilenamesChecked)}
    />
    <p>
      {t("clientPanelDownload:downloadOnlySpecificFiles")}
      <br />
      {t("clientPanelDownload:smallPhotos640X480")}
      <br />
      {t("clientPanelDownload:largePhotos1500X1000")}
    </p>
    <Card.Group itemsPerRow={4}>
      {mediaItems
        .filter(mediaItem => !tourIsArchived || (tourIsArchived && mediaItem.downloads.length > 0))
        .map(mediaItem => (
          <Card key={mediaItem.id}>
            {!tourIsArchived && <Image src={mediaItem.thumbnailLarge} wrapped ui={false} />}
            <Card.Content>{t("clientPanelDownload:mediaIdItemUiId", { mediaItemUuid: mediaItem.uuid })}</Card.Content>
            <Card.Content extra>
              {mediaItem.downloads.map(mediaItemDownloadInfo => (
                <MediaItemDownloadInfoSection
                  key={mediaItemDownloadInfo.uuid}
                  useShortFilenames={model.useShortFilenamesChecked}
                  mediaItemDownloadInfo={mediaItemDownloadInfo}
                  token={token}
                />
              ))}
            </Card.Content>
          </Card>
        ))}
    </Card.Group>
  </Segment>
));

IndividualDownload.propTypes = {
  mediaItems: PropTypes.arrayOf(PropTypes.instanceOf(MediaItem)),
  t: PropTypes.func.isRequired,
  token: PropTypes.string,
  model: PropTypes.shape({
    useShortFilenamesChecked: PropTypes.bool,
  }),
  setProperty: PropTypes.func.isRequired,
  tourIsArchived: PropTypes.bool.isRequired,
};

export default withTranslation()(IndividualDownload);
